import { Component} from '@angular/core';
import { inOutAnimation } from '../../animations';
import { AlertService } from 'src/app/core/alert.service';
import { ActivatedRoute, Router } from '@angular/router';
import { BaseService } from 'src/app/shared/base/base.service';
import { ProfileService } from 'src/app/inside-layout/routes/profile/profile.service';
import { FormBuilder, FormGroup, Validators, ValidatorFn, AbstractControl, ValidationErrors } from '@angular/forms';

export const passwordMatchValidator: ValidatorFn = (formGroup: AbstractControl): ValidationErrors | null => {
  const newPassword = formGroup.get('newPassword')?.value;
  const repeatPassword = formGroup.get('repeatPassword')?.value;

  return newPassword === repeatPassword ? null : { passwordsMismatch: true };
};

@Component({
  selector: 'app-forgot-password',
  templateUrl: './forgot-password.component.html',
  styleUrls: ['./forgot-password.component.scss'],
  animations: [ inOutAnimation ]
})
export class ForgotPasswordComponent {

  public formData: FormGroup;

   constructor(
      private formBuilder: FormBuilder,
      private alertService: AlertService,
      public router: Router,
      protected baseService: BaseService,
      private profilService: ProfileService,
      private activatedRoute: ActivatedRoute
    ) { 
      this.createForm();
    }

  onSubmit() {
    const data = {
      oldPassword: '',
      newPassword: this.formData.value.newPassword
    };

    const token = this.activatedRoute.snapshot.paramMap.get('token')
      this.profilService.newPassword(token, data, () => {
        this.alertService.success('USERS.PASSWORD_CHANGE_SUCCESS');
        this.formData.reset();
      }, () => {
        this.alertService.error('ERRORS.GENERAL');
      });
      this.router.navigate(['login'])
  }

  private createForm() {
    this.formData = this.formBuilder.group({
      newPassword: ['', [Validators.required]],
      repeatPassword: ['', [Validators.required]]
    }, { validators: passwordMatchValidator });
  }   

}
